import {ChangeDetectionStrategy, Component, ElementRef, Injectable, input, viewChild} from "@angular/core";
import {AgendaelementId, GruppeId, OpprettKommentarSpesifikasjon} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {KommentarDatatjeneste} from "felles-ng2/tjenester/datalager/KommentarDatatjeneste";
import {KommentarTraaderKomponent} from "web-ng2/moduler/kommentar/komponenter/kommentar-traader/kommentar-traader";
import {NyKommentarTraadKomponent, NyKommentarTraadKomponentAvhengigheter, NyKommentarTraadKomponentAvhengigheter_DI_TOKEN} from "web-ng2/moduler/kommentar/komponenter/ny-kommentar-traad/ny-kommentar-traad";
import {scrollTilBunn} from "web-ng2/delt/dom/scrollIntoView";

const debug = initDebugger('SakKommentarerKomponent');

@Component({
    selector: 'sak-kommentarer',
    templateUrl: 'sak-kommentarer.html',
    styleUrl: 'sak-kommentarer.scss',
    imports: [
        KommentarTraaderKomponent,
        NyKommentarTraadKomponent
    ],
    providers: [
        { provide: NyKommentarTraadKomponentAvhengigheter_DI_TOKEN, useExisting: SakKommentarerKomponent }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SakKommentarerKomponent implements NyKommentarTraadKomponentAvhengigheter {
    static ajsSelector = 'sakKommentarer';

    private nyKommentarTraadKomponent = viewChild.required(NyKommentarTraadKomponent);

    sakId = input.required< AgendaelementId>();
    gruppeId = input.required< GruppeId>();

    constructor(private avhengigheter: SakKommentarerKomponentAvhengigheter, private el: ElementRef) {
    }

    nyTraadFullSkjemaAktivert(aktivert: boolean) {
        if (!aktivert) return;
        //scroller til bunnen av komponenten slik at registrer/avbryt knappene er synlige
        scrollTilBunn(this.el.nativeElement, 50);
    }

    /** Flytter markør inn i kommentar-tekstfeltet for ny kommentar-tråd */
    settMarkørINyKommentartrådFelt() {
        this.nyKommentarTraadKomponent().fokus()
    }

    //NyKommentarTraadKomponentAvhengigheter implementasjon

    async opprettKommentar(spesifikasjon: OpprettKommentarSpesifikasjon): Promise<void> {
        await this.avhengigheter.opprettKommentar(this.sakId(), spesifikasjon);
    }

    //private hjelpemetoder

}

@Injectable()
export class SakKommentarerKomponentAvhengigheter {

    constructor(private kommentarDatatjeneste: KommentarDatatjeneste) {
    }

    async opprettKommentar(sakId: AgendaelementId, spesifikasjon: OpprettKommentarSpesifikasjon): Promise<void> {
        await this.kommentarDatatjeneste.opprettKommentarPåSak(sakId, spesifikasjon);
    }
}
